<template>
  <div class="sharecar_search">
    <label for="companyName">公司名称
      <el-input v-model="inputname"
                size="small"
                placeholder="请输入公司名称"
                class="companyName"></el-input>
    </label>
    <span class="imp">出发地</span>
    <el-cascader size="small"
                 class="addressStyle"
                 @active-item-change="handleItemChange"
                 :options="options"
                 v-model="addressFrom"
                 @change="handleChangeFrom">
    </el-cascader>
    <span class="imp">目的地</span>
    <el-cascader size="small"
                 class="addressStyle"
                 :options="options"
                 v-model="addressTo"
                 @active-item-change="handleItemChange"
                 @change="handleChangeTo">
    </el-cascader>
    <el-button class="search-submit"
               type="primary"
               @click="onSubmit">
      查询
    </el-button>
  </div>
</template>
<script>
// import { regionData, CodeToText } from 'element-china-area-data'
import Bus from '../../Bus.js'
import {
  lowSource,
  provinceList,
  cityList,
  areaList
} from 'apis/index'
import { mapState } from 'vuex'
export default {
  name: 'Search',
  data () {
    return {
      // originData: [],
      options: [],
      addressFrom: [],
      addressTo: [],
      // CodeToText,
      from: '',
      to: '',
      address: '',
      inputname: ''
    }
  },
  computed: mapState({
    lowsourceInfo: state => state.lowsource.lowsourceInfo
  }),
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
      }
    },
    async handleItemChange (val) {
      console.log('active item:', val)
      // console.log(val)
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
      // console.log('---', this.options)
    },
    getAddressText (value) {
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
    },
    onSubmit () {
      lowSource({
        companyName: this.inputname,
        startingAddressName: this.from,
        endAddressName: this.to
      }).then(res => {
        if (res.data.code === 0) {
          let searchInfo = {
            companyName: this.inputname,
            startingAddressName: this.from,
            endAddressName: this.to
          }
          Bus.$emit('getSearchInfo', searchInfo)
          let lowsourceInfo = res.data.data.pagination
          this.$store.commit('lowsource/updateData', lowsourceInfo)
          // console.log(lowsourceInfo)
        }
      })
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
    },
    handleChangeTo (value) {
      this.getAddressText(value)
      this.to = this.address
    }
    // getSearchInfo () {
    //   let searchInfo = {
    //     from: this.from,
    //     to: this.to,
    //     companyName: this.inputname
    //   }
    //   console.log(this.searchInfo)
    //   Bus.$emit('getSearchInfo', searchInfo)
    // }
  }
}
</script>
<style lang="stylus"  >
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.sharecar_search
  padding-bottom 20px
  .companyName
    width 150px
    margin 0 20px 0 10px
  .inline-input
    margin 0 20px 0 10px
  .addressStyle
    width 150px
    margin 0 20px 0 10px
    line-height 30px
  .el-select
    margin 0 20px
  .search-submit
    padding 5px 20px
    background #fff
    font-size 12px
    text-align right
    float right
    color $bgColor
    &:hover
      background $bgColor
      color #fff
  .el-form--inline .el-form-item__label
    size12()
</style>
